(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if(location.hash != '') {
    const details = document.querySelector(location.hash);
    if(details) details.setAttribute('open', '');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-steps"] && !Shopify.designMode) return;
  try {
    
  const stepsSwiper = document.querySelector('[data-sustainability-steps-swiper]');
  if(stepsSwiper) {
    setTimeout(() => {
      new Swiper(stepsSwiper, {
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 12,
      })
    }, 300);
  }

  } catch(e) { console.error(e); }
})();
})();
